export const getBalance = `
   query getBalance {
       getBalance {
           available {
               amount
               currency
               sourceTypes {
                   bankAccount
                   card
                   fpx
               }
           }
           connectReserved {
               amount
               currency
           }
           instantAvailable {
               amount
               currency
           }
           livemode
           pending {
               amount
               currency
           }
       }
   }
`;
